import * as Sentry from "@sentry/react";

// Initialize Sentry only when a DSN is provided and not in development
const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const isEnabled = !!dsn && import.meta.env.MODE !== "development";

if (isEnabled) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
  });
}

export { Sentry };


